<template>
  <div class="skill_type" v-if="model">
    <div class="name">{{ model.data.name }}</div>
    <skill v-for="(item, i) in model.findSkillList()" :key="i" :model="item" />
  </div>
</template>

<script>

import Skill from '@/components/screen-resume/skill';

export default {
    name       : "SkillType",
    components : { Skill },
    props      : {
        model : {
            type : Object
        }
    }
};

</script>

<style scoped>

.skill_type {
    background-image:-webkit-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-moz-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:-ms-linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    background-image:linear-gradient(to right, rgba(var(--main-gray-rgb), 0.5), rgba(var(--main-gray-rgb), 0.1));
    padding:10px;
    margin-top:20px;
    transition:box-shadow 1000ms;
    position:relative;
}

.skill_type:first-child {
    margin-top:0px;
}

.skill_type:before {
    content:"";
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    box-shadow:0px 0px 15px 5px var(--white-orange);
    opacity:0;
    transition:opacity 3000ms;
}

.skill_type:hover:before {
    opacity:1;
    transition:opacity 500ms;
}

.skill_type .name {
    font-size:18px;
}

</style>
